var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`lang-${_vm.$i18n.locale}`,attrs:{"id":"app"}},[(_vm.responsiveState.isDesktop)?_c('HeaderNavDesktop'):_c('HeaderNavMobile'),_c('router-view'),(_vm.responsiveState.isDesktop)?_c('FooterNav'):_c('FooterNavMobile'),_c('CookieConsent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }